module.exports = __webpack_public_path__ + "images/emoji/corn.22b5bcc8c2d872c970d0.png";